import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Icon, Fab, Tooltip } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    width: '48px',
    height: '48px',
  },
}))

const FabButton = ({ children, className, title, ...props }) => {
  const classes = useStyles()
  return (
    <Tooltip title={title} placement="bottom">
      <Fab color="primary" className={clsx(classes.root, className)} {...props}>
        <Icon>{children}</Icon>
      </Fab>
    </Tooltip>
  )
}

FabButton.propTypes = {
  children: PropTypes.string,
  title: PropTypes.string,
}

export default FabButton
